var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickRecentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.244 0.217285C7.21882 0.217285 0.688721 6.74738 0.688721 14.7725C0.688721 22.7977 7.21882 29.3278 15.244 29.3278C23.2691 29.3278 29.7992 22.7977 29.7992 14.7725C29.7992 6.74738 23.2691 0.217285 15.244 0.217285ZM15.244 26.9254C8.54546 26.9254 3.09455 21.4745 3.09455 14.776C3.09455 8.07747 8.54546 2.62655 15.244 2.62655C21.9425 2.62655 27.3934 8.07747 27.3934 14.776C27.3934 21.4745 21.9425 26.9254 15.244 26.9254Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2166 7.79575C15.5533 7.79575 15.0137 8.33534 15.0137 8.99866V15.5184H8.4939C7.83058 15.5184 7.29099 16.058 7.29099 16.7214C7.29099 17.3847 7.83058 17.9243 8.4939 17.9243H16.2166C16.8799 17.9243 17.4195 17.3847 17.4195 16.7214V8.99866C17.4195 8.33534 16.8799 7.79575 16.2166 7.79575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickRecentIcon);
export default __webpack_public_path__ + "static/media/quick_recent_icon.83a92a4b9720a12b61f4ce8f835ea003.svg";
export { ForwardRef as ReactComponent };